import React, {Component, Fragment} from 'react';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import NavTop from '../../containers/NavTop/NavTop';
import {Divider} from 'antd';
import './ContactRemoteRxPage.css';
// import ContactSection from '../../containers/ContactSection/ContactSection';
import WrappedContactForm from '../../common/ContactForm/ContactForm';
import QuoteBlock from '../../common/QuoteBlock/QuoteBlock';

class ContactRemoteRxPage extends Component {

  constructor(props){
    super(props);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  
  componentWillMount(){
    let {pageOn} = this.props;
    console.log(pageOn);
  }

  render() {
    return (
      <Fragment>
        <Helmet>
            <meta charSet="utf-8" />
            <title>RealTimeTouch.com - Contact page</title>
            <link rel="canonical" href="https://www.realtimetouch.com/contact/" />
        </Helmet>
        <NavTop pageOn={this.props.pageOn} />
        <div className="ContactRemoteRxPage--subnavbar-container mobileoff">
          <div className="ContactRemoteRxPage--subnavbar center mobileoff">
          </div>  
          <div className="ContactRemoteRxPage--subnavbar2 center mobileoff">
          </div>
          <h2 className="ContactRemoteRxPage--subnavbar-headline mobileoff font-special-heading">Real Time Touch: Remote RX PDF</h2>
        </div>
        <div className="ContactRemoteRxPage--container">
          <div className="ContactRemoteRxPage--container-subheading">
            <div className="mobileon mobile-heading2">Real Time Touch: Remote RX PDF</div>
 
            {/* <h4 className="ContactRemoteRxPage--subheadline">Find out more about Real Time Touch technology and intellectual property</h4> */}
            {/* <p className="ContactRemoteRxPage--body">We're available to discuss possible partnerships, and our designs and technologies.</p> */}
            {/* <QuoteBlock quote="4" qimg="remoterx" background="QuoteBlock--container-inner-none" /> */}
            <img src="https://www.realtimetouch.com/images/remoterx/dispenser-phone-frontpage-2.jpg" style={{marginBottom:20, marginTop:10, maxWidth:300, padding:5,border:'1px solid silver'}}/>
        
            <div style={{fontSize: 16, color:'black', width:400, margin:'0 auto'}}>
            <h3> <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" style={{marginRight: 7}} />Remote RX Info &amp; PDF</h3>"I'd like to request more info about Real Time Touch and it's Remote Rx Dispenser and Telemedicine Platform!"        
              </div>
          </div>
        {/* <div className=""><Divider /></div> */}

          <div className="ContactRemoteRxPage--form"> 
            {/* <WrappedContactForm myMsg="remoterx" buttonMsg='Request Remote Rx PDF'/> */}
            <QuoteBlock quote="3" background="QuoteBlock--container-inner-none" />
            <p> </p>
          </div>
        </div>
      </Fragment>
    )
  }
 }

export default ContactRemoteRxPage;


// WEBPACK FOOTER //
// ./src/pages/ContactRemoteRxPage/ContactRemoteRxPage.js